import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class EngineeringCoursesDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  
				  <p>As pioneers in educating and coaching students to land their dream job through competitive and professional exams, we understand the technicalities, nuances and nature of the work that goes into it. We guide and advise our students with career planning and detailed information on the types of courses and exams that they can undertake to achieve their interests and aspirations.
                    </p>
                    <p>We understand that every student is different and has their own set of strengths and weaknesses. Through our engineering guidance program, we strive to understand with our students the skill sets and personalities required for each career and help the students prepare for them.
                    </p>
                    </ScrollAnimation>	

					<ScrollAnimation animateIn="fadeInRight"><br/>
						<p>Our engineering and architecture guidance program is focused on-
						</p>
						<ul>
                            <li>Training the students on career guidance and decisions and helping them explore new opportunities based on their interests.</li>
                            <li>Providing complete information on course requirements and planning.</li>
                            <li>Helping students analyse and understand the courses based on their interests and guiding them through the enrollment process for NEET, JEE, Architecture, GATE, NET, SLET, IES etc.</li>
                        </ul>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight"><br/>
                       <p>The engineering and architecture guidance program at MIET not only supports the students for competitive and professional exams but also encourages them to develop soft skills and practical knowledge that will improve their employability skills for various post-examination processes such as field training, interviews and professional scenarios. Periodically, soft skill training sessions are held with the help of internal resource people and other specialists.</p>
                        <p>We also host academic experts to interact with our students through guest lectures, workshops or seminars, aiding them in digging deeper into knowledge in their fields of interest. These experts share their valuable insights on industry trends, news, work practices and up-to-the-minute advancements to keep the students on their feet. </p>
                    </ScrollAnimation>

                    
                  </div>
		      </div>
			  <Sidebar courseRestriction="Engineering and Architecture Guidance Program"/>
		    </div>
		  </div>
		</div>

        }
}

export default EngineeringCoursesDetails